import React, { useEffect, useState, useRef, useMemo } from "react";
import { set, useForm } from "react-hook-form";
import axios from "axios";
import { useOutletContext, Link } from "react-router-dom";
import $, { data } from "jquery";
import * as pdfjsLib from "pdfjs-dist";
import * as mammoth from "mammoth";
import toastr from "../../utils/toast";
import { MaterialReactTable } from "material-react-table";
import { openInAppTab } from "../../utils/tabNavigation";
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

function SearchRole({
  submit,
  selectedDesignation,
  selectedCountry,
  selectedFunction,
  selectedIndustry,
}) {
  const { setGlobalLoading, token } = useOutletContext();
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
    watch,
  } = useForm();

  const [text, setText] = useState("");
  const [file, setFile] = useState(null);
  const [functions, setFunctions] = useState([]);
  const [country, setCountry] = useState([]);
  const [Industries, setIndustries] = useState([]);
  const [keywords, setkeywords] = useState([]);
  const [roles, setRoles] = useState([]);
  const [gtpfunction, setgptfunction] = useState(null);
  const [gtpindustry, setgptindustry] = useState(null);
  const [gtpcountry, setgptcountry] = useState(null);
  const [gptdesignation, setdesignation] = useState(null);
  const [options, setOptions] = useState([]);
  const [myroles, setmyroles] = useState([]);
  const [selectedmyroles, setselectedmyroles] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [arr, setArr] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [rowSelection, setRowSelection] = useState({});

  const onSubmit = async (data) => {
    console.log("gptcountry", gtpcountry);
    console.log("gptfunction", gtpfunction);
    console.log("gptindustry", gtpindustry);
    console.log("gptdesignation", gptdesignation);
    const countries_array = selectedCountry.map((item) => item.value);
    const industries_array = selectedIndustry.map((item) => item.value);
    data = {
      ...data,
      designation: selectedDesignation || gptdesignation,
      country: countries_array || gtpcountry,
      functions: selectedFunction || gtpfunction,
      industry: industries_array || gtpindustry,
    };

    console.log("This is formdata", data);

    try {
      setGlobalLoading(true);
      // Exclude `myroles` from data
      const { myroles, ...filteredData } = data;

      const response = await axios.post(
        `${API_BASE_URL}/candidates/search_by_role`,
        {
          formdata: filteredData,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.length > 0) {
        setOptions(response.data);
        console.log(response.data);
        const my_roles = await axios.get(
          `${API_BASE_URL}/common_controller/get_my_roles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (my_roles.data.options.length > 0) {
          setmyroles(my_roles.data.options);
        }
      } else {
        setmyroles([]);
        setOptions([]);
        setArr(true);
      }
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Full Name",
        accessorKey: "full_name",
        Cell: ({ row }) => (
          <div className="d-flex align-items-center">
            <Link
              to={`/candidates/view/${row.original.id}`}
              target="_blank"
              className="avatar avatar-md border avatar-rounded"
              onClick={(event) => {
                event.preventDefault();
                openInAppTab(
                  `/candidates/view/${row.original.id}`,
                );
              }}
            >
              <img
                src={
                  row.original.userpic
                    ? `${PINE_BASE_URL}/files/candidates/picture/${row.original.userpic}`
                    : `${PINE_BASE_URL}/files/candidates/picture/no-pic.png`
                }
                className="img-fluid"
                alt="img"
              />
            </Link>
            <div className="ms-2 d-flex">
              <h6 className="fw-medium fs-12 mbm-12">
                <Link
                  to={`/candidates/view/${row.original.id}`}
                  target="_blank"
                  onClick={(event) => {
                    event.preventDefault();
                    openInAppTab(
                      `/candidates/view/${row.original.id}`,
                    );
                  }}
                >
                  {row.original.firstname} {row.original.lastname}
                </Link>
              </h6>
              {row.original.linkdin_url && (
                <a
                  className="ms-2"
                  target="_blank"
                  href={row.original.linkdin_url}
                >
                  <i className="fa-brands fa-linkedin"></i>
                </a>
              )}
            </div>
          </div>
        ),
      },
      { header: "Company", accessorKey: "current_company" },
      {
        header: "Phone",
        accessorKey: "phone",
        Cell: ({ cell }) => cell.getValue() || "-",
      },
      {
        header: "Email",
        accessorKey: "email",
        Cell: ({ cell }) => cell.getValue() || "-",
      },
      { header: "Designation", accessorKey: "designation" },
      { header: "Industry", accessorKey: "industry_master" },
      { header: "Industry Minor", accessorKey: "minor_industry" },
      { header: "M Function", accessorKey: "function_name" },
      { header: "Country", accessorKey: "location" },
    ],
    [],
  );

  useEffect(() => {
    async function getFunctions() {
      try {
        setGlobalLoading(true);
        const functions_list = await axios.get(
          `${API_BASE_URL}/common_controller/get_major_functions`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (functions_list.data.options.length > 0) {
          setFunctions(functions_list.data.options);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setGlobalLoading(false);
      }
    }
    async function get_geography() {
      try {
        setGlobalLoading(true);
        const response = await axios.get(
          `${API_BASE_URL}/common_controller/get_countries_list`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.data.options.length > 0) {
          setCountry(response.data.options);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setGlobalLoading(false);
      }
    }
    async function get_industry() {
      try {
        setGlobalLoading(true);
        const response = await axios.get(
          `${API_BASE_URL}/common_controller/get_master_industry_list`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.data.options.length > 0) {
          setIndustries(response.data.options);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setGlobalLoading(false);
      }
    }
    async function get_roles() {
      try {
        setGlobalLoading(true);
        const response = await axios.get(
          `${API_BASE_URL}/common_controller/get_active_roles_list_with_jd`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.data.options.length > 0) {
          setRoles(response.data.options);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setGlobalLoading(false);
      }
    }

    get_roles();
    getFunctions();
    get_geography();
    get_industry();
  }, [token]);

  const handleFileChange = (e) => {
    const id = e.target.value;
    async function get_role_details(id) {
      setGlobalLoading(true);
      try {
        const response = await axios.post(
          `${API_BASE_URL}/ai_candidates/get_role_details`,
          {
            role_id: id,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.data.length > 0) {
          submit(response.data[0]);

          const gptkeywords = response.data[0].reply;
          const MatchedgptKeywords = gptkeywords.map((k) => k.value);

          setkeywords(gptkeywords);
          setValue("keywords", MatchedgptKeywords);

          setTimeout(() => {
            const $selectKeywords = $("select[name='keywords']");
            $selectKeywords.empty();
            gptkeywords.forEach((keyword) => {
              const option = new Option(
                keyword.label,
                keyword.value,
                true,
                true,
              );
              $selectKeywords.append(option);
            });
            $selectKeywords.trigger("change");
          }, 100);

          setValue("designation", response.data[0].designation);
          setdesignation(response.data[0].designation);
          const gptCountry = response.data[0].country;
          setgptcountry(gptCountry);
          const MatchedCounty = country
            .filter((c) => [gptCountry].includes(c.value))
            .map((c) => c.value);

          if (MatchedCounty.length > 0) {
            setValue("country", MatchedCounty); // <-- update form field too
          }
          const gtpindustry = response.data[0].industry;
          setgptindustry(gtpindustry);
          const MatchedIndustry = Industries.filter((c) =>
            [gtpindustry].includes(c.value),
          ).map((c) => c.value);

          if (MatchedIndustry.length > 0) {
            setValue("industry", MatchedIndustry); // <-- update form field too
          }

          setTimeout(() => {
            $("select[name='country']").val(MatchedCounty).trigger("change");
            $("select[name='industry']").val(MatchedIndustry).trigger("change");
          }, 0);
          setgptfunction(response.data[0].function);
          setValue("functions", response.data[0].function);
        }
        // console.log(response);
      } catch (error) {
        console.log(error);
      } finally {
        $("select[name='country']").attr("disabled", false);
        $("select[name='functions']").attr("disabled", false);
        $("select[name='industry']").attr("disabled", false);
        setGlobalLoading(false);
      }
    }

    get_role_details(id);
  };

  const role_id = watch("role_id");
  //   const hasHandledFileChange = useRef(false);

  useEffect(() => {
    // console.log(hasHandledFileChange.current);
    if (role_id) {
      setOptions([]);
      handleFileChange({ target: { value: role_id } });
      //   hasHandledFileChange.current = true;
    }

    // const $selectCountry = $("select[name='country']");
    // $selectCountry.select2({
    //   placeholder: "Select Country",
    // });

    // $selectCountry.on("change", function (e) {
    //   const selectedValues = $(this).val();
    //   setValue("country", selectedValues || []); // update react-hook-form
    // });

    // const $selectIndustry = $("select[name='industry']");
    // $selectIndustry.select2({
    //   placeholder: "Select Industry",
    // });

    // $selectIndustry.on("change", function (e) {
    //   const selectedValues = $(this).val();
    //   setValue("industry", selectedValues || []); // update react-hook-form
    // });

    const $selectKeywords = $("select[name='keywords']");
    $selectKeywords.select2({
      placeholder:
        "Select active role to extract skills or add new skills with comma separated",
      tags: true,
      tokenSeparators: [","],
      createTag: function (params) {
        const term = $.trim(params.term);

        if (term === "") {
          return null;
        }

        // Check if this term already exists (case-insensitive match)
        const exists = $selectKeywords.find("option").filter(function () {
          return $(this).text().toLowerCase() === term.toLowerCase();
        }).length;

        if (exists > 0) {
          return null;
        }

        // Allow custom tag
        return {
          id: term,
          text: term,
          newTag: true, // mark it as a new tag
        };
      },
    });

    $selectKeywords.on("change", function (e) {
      const selectedValues = $(this).val();
      setValue("keywords", selectedValues);
    });
    const $selectRole = $("select[name='role_id']");

    $selectRole.select2({
      placeholder: "Select Active Role",
      width: "100%",
      matcher: function (params, data) {
        if ($.trim(params.term) === "") return data;

        // Normalize function: remove brackets, trim, remove extra spaces, lowercase
        const normalize = (str) =>
          str
            .replace(/[\(\)]/g, "") // remove parentheses
            .replace(/\s+/g, " ") // collapse multiple spaces to one
            .trim() // remove leading/trailing spaces
            .toLowerCase();

        const term = normalize(params.term); //cleaned version of what user typed
        const text = normalize(data.text || ""); //cleaned version of the dropdown option text

        // Check if normalized term exists inside normalized text
        if (text.indexOf(term) > -1) {
          return data;
        }

        return null; // no match
      },
    });

    $selectRole.on("change", function (e) {
      const selectedValues = $(this).val();
      setValue("role_id", selectedValues);
    });

    return () => {
      // $selectCountry.select2("destroy");
      $selectKeywords.select2("destroy");
      $selectRole.select2("destroy");
      // $selectIndustry.select2("destroy");
    };
  }, [role_id]);

  useEffect(() => {
    const $selectMyroles = $("select[name='myroles']");
    $selectMyroles.select2({
      placeholder: "Select the role you are working on",
    });

    $selectMyroles.on("change", function (e) {
      const selectedValues = $(this).val();
      if (selectedValues.length > 0) {
        $("#discard_candidates").removeClass("hide");
        setselectedmyroles(selectedValues);
      } else {
        $("#discard_candidates").addClass("hide");
        setselectedmyroles([]);
      }
      setValue("myroles", selectedValues || []); // update react-hook-form
    });

    return () => {
      $selectMyroles.select2("destroy");
    };
  }, [myroles]);

  const onSubmitmyroles = async (data) => {
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/candidates/search_by_role`,
        {
          formdata: data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.length > 0) {
        setOptions(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    const ids = Object.keys(rowSelection);

    if (ids.length > 0) {
      $("#map_candidates").removeClass("hide");
      setSelectedIds(ids);
    } else {
      $("#map_candidates").addClass("hide");
      setSelectedIds([]);
    }
  }, [rowSelection, options]);

  const mapCandidates = async (formData) => {
    if (!selectedmyroles || selectedmyroles.length === 0) {
      // Show error, focus the select2, and stop
      const $selectMyroles = $("select[name='myroles']");

      alert("Please select the role you are working on");
      // Focus on the select2 dropdown
      $selectMyroles.select2("open");

      return; // Prevent further processing
    }

    data = {
      selectedId: selectedIds,
      selectedRole: selectedmyroles,
    };
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/ai_candidates/map_to_role`,
        {
          data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success == true) {
        setOptions((prevOptions) =>
          prevOptions.filter((item) => !selectedIds.includes(String(item.id))),
        );
        setRowSelection({});
        setSelectedIds([]);
        toastr.success(response.data.message);
      } else {
        toastr.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGlobalLoading(false);
    }

    // Proceed with mapping logic here
  };

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Search By Role</h2>
            <p className="fs-12">
              Enter an active role, and we'll help you find the relevant
              candidates.
            </p>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Select an existing role{" "}
                      <span className="text-danger">
                        *{errors.role_id && errors.role_id.message}
                      </span>
                    </label>
                    <select
                      {...register("role_id", {
                        required: "Required",
                      })}
                      className="form-select"
                    >
                      <option></option>
                      {roles.length > 0
                        ? roles.map((value, index) => (
                            <option key={index} value={value.value}>
                              {value.label}
                            </option>
                          ))
                        : ""}
                    </select>
                  </div>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Designation</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Designation"
                      {...register("designation")}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Geography</label>
                    <select
                      {...register("country")}
                      className="form-select select2"
                      multiple
                      disabled={true}
                    >
                      {country.length > 0
                        ? country.map((value, index) => (
                            <option key={index} value={value.value}>
                              {value.label}
                            </option>
                          ))
                        : ""}
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Industry</label>
                    <select
                      {...register("industry")}
                      className="form-select custom-functionselect"
                      multiple
                      disabled={true}
                    >
                      <option value="">Select Industry</option>
                      {Industries.length > 0
                        ? Industries.map((value, index) => (
                            <option key={index} value={value.value}>
                              {value.label}
                            </option>
                          ))
                        : ""}
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Major Functions</label>
                    <select
                      {...register("functions")}
                      className="form-select custom-functionselect"
                      disabled={true}
                    >
                      <option value="">Select Function</option>
                      {functions.length > 0
                        ? functions.map((value, index) => (
                            <option key={index} value={value.value}>
                              {value.label}
                            </option>
                          ))
                        : ""}
                    </select>
                  </div>
                </div>
              </div> */}
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Extracted Skills </label>
                    <select
                      className="form-select select2 keyword_field_custom_height"
                      multiple
                      {...register("keywords")}
                    >
                      {keywords.length > 0
                        ? keywords.map((value, index) => (
                            <option selected key={index} value={value.value}>
                              {value.label}
                            </option>
                          ))
                        : ""}
                    </select>
                  </div>
                </div>
              </div>
              <div className="text-end">
                <button type="submit" className="btn btn-primary">
                  Search Candidates
                </button>
              </div>
            </form>
          </div>
        </div>
        {myroles && myroles.length > 0 ? (
          <form onSubmit={handleSubmit(onSubmitmyroles)}>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <select
                      {...register("myroles")}
                      className="form-select select2"
                      style={{ width: "44.917px" }}
                    >
                      <option value={""}>
                        Select the role you are working on
                      </option>
                      {myroles.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-8">
                    <button
                      className="btn btn-info hide fs-10"
                      id="discard_candidates"
                      type="submit"
                    >
                      <i className="fe fe-eye-off"></i> Exclude candidates of
                      workstation
                    </button>
                    <a
                      href="javascript:void(0)"
                      className="btn btn-success hide fs-10"
                      id="map_candidates"
                      style={{ marginLeft: "10px" }}
                      onClick={handleSubmit(mapCandidates)}
                    >
                      <i className="ti ti-checks"></i> Add candidates to
                      workstation
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        ) : (
          ""
        )}
        <div className="card">
          <div className="card-body">
            <h5 className="mb-3">Search result</h5>
            <div className="row">
              <div className="col-md-12 text-center">
                {options.length > 0 ? (
                  <MaterialReactTable
                    key={options.length}
                    columns={columns}
                    data={options}
                    getRowId={(row) => row.id}
                    enableRowSelection
                    enablePagination
                    enableColumnFilters
                    enableSorting
                    onRowSelectionChange={setRowSelection}
                    state={{ rowSelection }}
                    initialState={{
                      pagination: { pageIndex: 0, pageSize: 50 },
                      showColumnFilters: true,
                    }}
                  />
                ) : (
                  <>
                    <img
                      width={"16%"}
                      src="..\assets\img\icons\people_search_icon.png"
                    />
                    <p>
                      <b>
                        {arr === true
                          ? "No Candidate found."
                          : "No candidates yet! Start uploading JD for personalised results."}
                      </b>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SearchRole;
